<template>
  <div class="waybill-compile_img noselect" :class="{'kye-image-resize-height': config && !config.height}">
    <div class="topContent" ref="topContent">
      <div>
        <slot name="btn" :imgConfig="imgConfig" :currentIndex="currentIndex - 1" :loadImgSrc="loadImgSrc"></slot>
      </div>
      <div v-if="showToolbar" class="btn-icon" :class="{ 'showGallery': showGallery }">
        <div class="btn-icon_left-wrap">
          <div class="btn-icon_left">
            <kye-button type="text" @click="imgLeft" v-show="!isFile" icon="layout layout-zuozhuan1">左转</kye-button>
            <kye-button type="text" @click="imgRight" v-show="!isFile" icon="layout layout-youzhuan1">右转</kye-button>
            <kye-button type="text" @click="imgBig" v-show="!isFile" icon="layout layout-fangda1">放大</kye-button>
            <kye-button type="text" @click="imgSmall" v-show="!isFile" icon="layout layout-suoxiao1">缩小</kye-button>
            <kye-button type="text" @click="imgRestore" v-show="!isFile" icon="layout layout-huanyuan">还原</kye-button>
            <kye-button v-if="showDownload" type="text" @click="downlandImage" icon="layout layout-xiazai" :disabled="!this.config.imgSrc.length">下载</kye-button>
            <kye-button v-if="showDelete" type="text" @click="deleteImage" icon="layout layout-delete" :disabled="!this.config.imgSrc.length">删除</kye-button>
            <template v-if="imgConfig.btns && imgConfig.btns.length > 0">
              <kye-button
                type="text"
                v-for="(item, index) in imgConfig.btns"
                :key="index"
                :auth="item.auth ? item.auth : ''"
                :icon="item.icon ? 'iconfont ' + item.icon : ''"
                @click="() => handleBtnsItemClick(item)"
                >{{ item.label }}</kye-button
              >
            </template>
          </div>
          <slot
            name="topbtn"
            :imgConfig="imgConfig"
            :imgConfigList="imgListData"
            :currentIndex="currentIndex - 1"
            :loadImgSrc="loadImgSrc"></slot>
        </div>
        <div class="btn-icon_right" v-if="imgListData.length > 1">
          <span class="pager">
            <el-button icon="layout layout-first" class="btn-text" type="text" @click="firstImge">
            </el-button>
            <el-button icon="layout layout-previous" class="btn-text" type="text" @click="prevImge">
            </el-button>
            <!-- <i class="layout layout-first" @click="firstImge" style="font-size: 12px">&nbsp;</i>
            <i class="layout layout-previous" @click="prevImge" style="font-size: 12px; margin-left: 5px">&nbsp;</i> -->
            <kye-number
              style="width: 40px; font-size: 14px"
              type="number"
              :min="1"
              :max="maxCurrentIndex"
              isPureNumber
              :clearable="false"
              :value="currentIndex"
              @change="changeCurrentIndex"></kye-number
            >&nbsp;/&nbsp;{{ imgListData.length }}&nbsp;
            <el-button icon="layout layout-next" class="btn-text" type="text" @click="nextImge">
            </el-button>
            <el-button icon="layout layout-last" class="btn-text" type="text" @click="lastImge">
            </el-button>
            <!-- <i class="layout layout-next" style="font-size: 14px; margin-right: 5px" @click="nextImge"></i>
            <i class="layout layout-last" style="font-size: 14px" @click="lastImge"></i> -->
          </span>
        </div>
      </div>
    </div>
    <div class="kye-imgage-content-wrap">
      <div class="kye-imgage-current-img" ref="imgWrap" :class="{ 'kye-image-user-set-height': config.height }">
        <slot name="img" :imgConfig="imgConfig" :imgConfigList="imgListData">
          <div
            class="imgbox"
            ref="imgbox"
            v-loading="loading"
            :style="{
              width: imgConfig.width ? imgConfig.width + 'px' : '100%',
              height: '100%',
              'will-change': isSvgImage(loadImgSrc) ? 'unset' : 'transform'
            }">
            <img
              style="object-fit: contain"
              height="100%"
              width="100%"
              ondragstart="return false;"
              @mousedown="ticketMousedow"
              @mouseout="ticketMouseout"
              @mouseup="ticketMouseup"
              @mousewheel="ticketMousewheel"
              @mousemove="ticketMousemove"
              ref="ticketImg"
              v-show="(!!loadImgSrc && loadImgStatus !== 'Failed') || loadImgStatus === 'Completed'"
              :src="loadImgSrc" />
            <div v-show="!loadImgSrc || loadImgStatus === 'Failed'">
              <div class="no-img">
                <i class="layout layout-icon_magnifier"></i>
                <span class="no-img-txt">{{ emptyText }}</span>
              </div>
            </div>
          </div>
        </slot>
      </div>
      <div
        v-if="loadImgStatus && showGallery && imgListData.length > 1"
        class="kye-imgage-list scroll-class"
        :style="imageListStyle"
        ref="kyeImgageList">
        <div
          class="kye-imgage-container"
          v-for="(item, index) in this.imgListData"
          :key="item.src + index"
          @click="changeCurrentIndex(index + 1)">
          <el-image
            lazy
            :src="item.src"
            style="height: 96px"
            :fit="imgFit"
            :class="{ 'active': loadImgSrc === item.src && index === currentIndex - 1 }">
            <div slot="error" style="display: flex; align-items: center; justify-content: center; height: 96px">
              <!-- <img v-if="isPdfSrc(item.src)" style="width: 30px" :src="getFileTypeIcon(item.src)" alt="" />
              <i class="el-icon-picture-outline" v-else></i> -->
              <img style="width: 30px" :src="getFileTypeIcon(item.src)" alt="" />
            </div>
          </el-image>
          <div class="kye-imgage-name" v-if="getFileInfo(item.src)">
            <p class="kye-imgage-value" :title="getFileInfo(item.src).name">{{ getFileInfo(item.src).name }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomContent" ref="bottomContent">
      <slot name="bottom" :imgConfig="imgConfig" :currentIndex="currentIndex - 1" :loadImgSrc="loadImgSrc"></slot>
    </div>
  </div>
</template>
<script>
import { isObject } from './utils'
import { getImgSuffix } from 'public/components/kye-preview/component/utils'
export default {
  name: 'kye-image',
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    },
    showDownload: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    beforeRemove: Function,
    showToolbar: {
      type: Boolean,
      default: true
    },
    emptyText: {
      type: String,
      default: '找不到图片'
    },
    imgFit: {
      type: String,
      default: 'cover'
    },
    imglist: Array,
    showGallery: {
      type: Boolean,
      default: true
    },
    resizeHeight: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    imageListStyle () {
      return this.config.height ? {'max-height': this.config.height + 'px'} : {}
    },
    isFile() {
      return (this.$props.config.pdfSrc || []).includes(this.loadImgSrc)
    },
    maxCurrentIndex() {
      return Array.isArray(this.imgConfig.imgSrc) ? this.imgConfig.imgSrc.length : 1
    },
    isImgObject() {
      return Array.isArray(this.imgConfig.imgSrc) && isObject(this.imgConfig.imgSrc[0])
    },
    imgListData() {
      // 对象数组结构直接使用
      if (this.isImgObject) {
        return this.imgConfig.imgSrc || []
      } else {
        // 字符串类型和字符串数组类型转换为对象数组
        if (typeof this.imgConfig.imgSrc === 'string') {
          return [
            {
              src: this.imgConfig.imgSrc,
              name: '',
              type: ''
            }
          ]
        } else if (Array.isArray(this.imgConfig.imgSrc)) {
          return this.imgConfig.imgSrc.map(url => ({
            src: url,
            name: '',
            type: ''
          }))
        }
        return []
      }
    }
  },
  data() {
    return {
      isMove: false, // 标记是否移动事件
      lastStatus: {
        scale: 1,
        rotate: 0,
        translateX: 0,
        translateY: 0,
        mouseX: 0,
        mouseY: 0
      },
      loadImgSrc: '',
      currentIndex: 1,
      loading: true,
      imgConfig: {
        width: 0,
        height: 600,
        imgSrc: '',
        maxScale: 4.0, // 最大放大倍数
        minScale: 0.5, // 最小放大倍数
        step: 0.06, // 每次放大、缩小 倍数的变化值
        clickStep: 0.3 // 按钮点击的放大缩小步进
      },
      loadImgStatus: '',
      localEmptyText: '',
      galleryHeight: 0
    }
  },
  methods: {
    updateImgConfigWidth() {
      const galleryWrapWidth = 155
      if (this.$props.showGallery && isFinite(this.imgConfig.width) && this.imgListData.length > 1) {
        if (this.imgConfig.width + galleryWrapWidth > this.imgConfig.width) {
          this.imgConfig.width -= galleryWrapWidth
          this.imgConfig.width = Math.max(this.imgConfig.width, 0)
        }
      }
    },
    handleBtnsItemClick(item) {
      const params = {
        currentIndex: this.currentIndex - 1,
        loadImgSrc: this.loadImgSrc
      }
      item.click && item.click(params)
    },
    initConfig() {
      this.imgConfig = { ...this.imgConfig, ...this.config }
      this.currentIndex = Number(this.imgConfig.index) + 1 || 1
      this.updateImgConfigWidth()
      if (this.imgListData) {
        if (this.imgListData.length === 1) {
          this.loadImgSrc = this.imgListData[0].src
        } else {
          const { src = '' } = this.imgListData[this.currentIndex - 1] || {}
          this.loadImgSrc = src
        }
      } else {
        this.loadImgSrc = ''
      }
      this.loadImg(this.loadImgSrc)
      this.$emit('change', this.currentIndex - 1)
    },
    loadImg(imgSrc) {
      this.loading = true
      this.localEmptyText = ''
      let img = new Image()
      img.src = imgSrc
      this.loadImgStatus = 'Pending'
      img.onload = () => {
        this.loading = false
        this.loadImgStatus = 'Completed'
        this.localEmptyText = ''
        setTimeout(() => {
          this.resizeImgWrapHeight()
        })
      }
      img.onerror = imgSrc => {
        this.loading = false
        this.loadImgStatus = 'Failed'
        this.localEmptyText = this.$props.emptyText
        setTimeout(() => {
          this.resizeImgWrapHeight()
        })
      }
      this.imgRestore()
    },
    isMax(key) {
      const max = this.imgConfig.maxScale
      let diffNumber = this.lastStatus.scale + key
      if (diffNumber >= max) {
        diffNumber = max
      }
      const number = this.lastStatus.scale >= max ? max : diffNumber
      return number
    },
    isMin(key) {
      const min = this.imgConfig.minScale
      let diffNumber = this.lastStatus.scale - key
      if (diffNumber <= min) {
        diffNumber = min
      }
      const number = this.lastStatus.scale <= min ? min : diffNumber
      return number
    },
    imgBig() {
      this.lastStatus.scale = this.isMax(this.imgConfig.clickStep)
      this.toTransfrom()
    },
    imgSmall() {
      this.lastStatus.scale = this.isMin(this.imgConfig.clickStep)
      this.toTransfrom()
    },
    toTransfrom() {
      let str = `translate3d(${this.lastStatus.translateX}px,${this.lastStatus.translateY}px,0.1px) scale3d(${this.lastStatus.scale},${this.lastStatus.scale},0.0001) rotate(${this.lastStatus.rotate}deg)`
      this.ticketImg = this.$refs.ticketImg
      if (!this.ticketImg) {
        return
      }
      this.ticketImg.style.transform = str
      this.ticketImg.style.webkitTransform = str
      this.ticketImg.style.msTransform = str
      this.ticketImg.style.omzTransform = str
    },
    imgLeft() {
      this.lastStatus.rotate = parseInt(this.lastStatus.rotate / 90) * 90 - 90
      this.toTransfrom()
    },
    imgRight() {
      this.lastStatus.rotate = parseInt(this.lastStatus.rotate / 90) * 90 + 90
      this.toTransfrom()
    },
    imgRestore() {
      this.lastStatus = {
        scale: 1,
        rotate: 0,
        translateX: 0,
        translateY: 0
      }
      this.toTransfrom()
    },
    windowToCanvas(x, y) {
      let box = this.$refs.imgbox.getBoundingClientRect()
      return {
        x: x - box.left,
        y: y - box.top
      }
    },
    drawImgByMove(x, y) {
      this.lastStatus.translateX = this.lastStatus.translateX + (x - this.lastStatus.mouseX)
      this.lastStatus.translateY = this.lastStatus.translateY + (y - this.lastStatus.mouseY)
      this.lastStatus.mouseX = x
      this.lastStatus.mouseY = y
      this.toTransfrom()
    },
    ticketMousedow(e) {
      this.isMove = true
      this.$refs.imgbox.style.cursor = 'move'
      let box = this.windowToCanvas(e.clientX, e.clientY)
      this.lastStatus.mouseX = box.x
      this.lastStatus.mouseY = box.y
    },
    ticketMouseout(e) {
      this.isMove = false
      this.$refs.imgbox.style.cursor = 'default'
    },
    ticketMouseup(e) {
      this.isMove = false
      this.$refs.imgbox.style.cursor = 'default'
    },
    ticketMousemove(e) {
      if (this.isMove) {
        let box = this.windowToCanvas(e.clientX, e.clientY)
        this.drawImgByMove(box.x, box.y)
      }
    },
    ticketMousewheel(e) {
      e.preventDefault()
      if (e.wheelDelta > 0) {
        this.lastStatus.scale = this.isMax(this.imgConfig.step)
      } else {
        this.lastStatus.scale = this.isMin(this.imgConfig.step)
      }
      this.toTransfrom()
    },
    prevImge() {
      let { imgSrc } = this.imgConfig
      if (Array.isArray(imgSrc) && imgSrc.length === 0) {
        this.currentIndex = 0
        return
      }
      this.currentIndex -= 1
      if (this.currentIndex === 0) {
        this.currentIndex = 1
      }
      this.lastStatus.rotate = 0
      this.toTransfrom()
      const { src = '' } = this.imgListData[this.currentIndex - 1] || {}
      this.loadImgSrc = src
      this.loadImg(this.loadImgSrc)
      this.$emit('change', this.currentIndex - 1)
    },
    nextImge() {
      let { imgSrc } = this.imgConfig
      if (Array.isArray(imgSrc) && imgSrc.length === 0) {
        this.currentIndex = 0
        return
      }
      this.currentIndex += 1
      if (this.currentIndex >= imgSrc.length) {
        this.currentIndex = imgSrc.length
      }
      this.lastStatus.rotate = 0
      this.toTransfrom()
      const { src = '' } = this.imgListData[this.currentIndex - 1] || {}
      this.loadImgSrc = src
      this.loadImg(this.loadImgSrc)
      this.$emit('change', this.currentIndex - 1)
    },
    firstImge() {
      let { imgSrc } = this.imgConfig
      if (Array.isArray(imgSrc) && imgSrc.length === 0) {
        this.currentIndex = 0
        return
      }
      this.currentIndex = 1
      this.lastStatus.rotate = 0
      this.toTransfrom()
      const { src = '' } = this.imgListData[this.currentIndex - 1] || {}
      this.loadImgSrc = src
      this.loadImg(this.loadImgSrc)
      this.$emit('change', this.currentIndex - 1)
    },
    lastImge() {
      let { imgSrc } = this.imgConfig
      if (Array.isArray(imgSrc) && imgSrc.length === 0) {
        this.currentIndex = 0
        return
      }
      this.currentIndex = imgSrc.length
      this.lastStatus.rotate = 0
      this.toTransfrom()
      const { src = '' } = this.imgListData[this.currentIndex - 1] || {}
      this.loadImgSrc = src
      this.loadImg(this.loadImgSrc)
      this.$emit('change', this.currentIndex - 1)
    },
    changeCurrentIndex(val) {
      this.currentIndex = val
      this.changeIndex(val - 1)
      this.$emit('change', this.currentIndex - 1)
    },
    changeIndex(index) {
      const i = Number(index)
      const imgSrcArr = this.imgListData
      if (i > -1 && imgSrcArr.length > 0) {
        this.currentIndex = i + 1
        this.loadImgSrc = imgSrcArr[i].src
        this.loadImg(this.loadImgSrc)
      }
    },
    handleKeydown(e) {
      if (e.keyCode === 37) {
        this.prevImge()
      } else if (e.keyCode === 39) {
        this.nextImge()
      }
    },
    isPdfSrc(url) {
      if (!this.$props.config.pdfSrc || !this.$props.config.pdfSrc.length) {
        return false
      }
      return (this.$props.config.pdfSrc || []).includes(url)
    },
    deletPdfSrcInileFlag(url) {
      const INILE_STR_FLAG = '&inline=true'
      return url.replace(INILE_STR_FLAG, '')
    },
    downlandImage() {
      const imgSrc = this.config.imgSrc
      const deletPdfSrcInileFlag = url => {
        if (this.isPdfSrc(url)) {
          url = this.deletPdfSrcInileFlag(url)
        }
        return url
      }
      if (Array.isArray(imgSrc)) {
        const url = deletPdfSrcInileFlag(this.config.imgSrc[this.currentIndex - 1])
        window.erpOpen(url)
      } else {
        const url = deletPdfSrcInileFlag(this.config.imgSrc)
        window.erpOpen(url)
      }
    },
    async deleteImage() {
      const currentIndex = this.currentIndex - 1
      const url = this.config.imgSrc[currentIndex]
      const info = this.getFileInfo(url)
      if (this.beforeRemove && typeof this.beforeRemove === 'function') {
        const beforeDownload = await this.beforeRemove(info)
        let flag = true
        if (beforeDownload && beforeDownload.then) {
          flag = await beforeDownload
        } else {
          flag = beforeDownload
        }
        // 与上传组件内部删除保持一致，false则不执行后续操作（预览组件内部true不执行后续操作）
        if (!flag) {
          return false
        }
      }
      await this.$confirm('确定要删除该文件吗？删除后不支持找回。', '提示')
      const params = { bizCode: info.bizCode, bizId: info.bizId, id: info.id }
      this.$http('file.deleteByBizAndId', params).then(res => {
        if (res) {
          this.imgConfig.imgSrc.splice(currentIndex, 1)
          this.currentIndex -= 1
          this.nextImge()
          this.$emit('remove', info)
          this.$message.success('删除成功')
        }
      })
    },
    scrollActiveImage() {
      if (!this.$refs.kyeImgageList) {
        return
      }
      const activeDom = this.$refs.kyeImgageList.querySelector('.el-image.active')
      activeDom && activeDom.scrollIntoViewIfNeeded()
    },
    resizeImgWrapHeight() {
      this.setDefaultHeight()
      if (this.$props.config.height) {
        return
      }
      let parentElement = this.$el.parentElement
      while (parentElement && !parentElement.classList.contains('el-dialog__body')) {
        parentElement = parentElement.parentElement
      }
      if (parentElement) {
        const { paddingTop, paddingBottom } = getComputedStyle(parentElement)
        const topContent = this.$refs.topContent.offsetHeight
        const bottomContent = this.$refs.bottomContent.offsetHeight
        const bodyMaxHeight = Number.parseInt(getComputedStyle(parentElement).height)
        // const bodyMaxHeight = Number.parseInt(this.$el.offsetHeight)
        const maxHeight =
          bodyMaxHeight - bottomContent - topContent - Number.parseInt(paddingTop) - Number.parseInt(paddingBottom) - 2 // 2是imgBox的boder
        if (isFinite(maxHeight)) {
          if (this.$refs.ticketImg) {
            this.$refs.ticketImg.style.maxHeight = maxHeight + 'px'
          }
          if (!this.loadImgSrc || this.loadImgStatus === 'Failed') {
            this.$refs.imgWrap.style.height = maxHeight + 'px'
          }
          if (this.loadImgStatus === 'Completed') {
            this.$refs.imgWrap.style.height = 'auto'
          }
          if (this.$refs.kyeImgageList) {
            this.$refs.kyeImgageList.style.maxHeight = maxHeight + 'px'
          }
        }
      }
    },
    fullScreenChange() {
      if (this.$props.config.height) {
        return
      }
      this.$nextTick(() => {
        this.resizeImgWrapHeight()
      })
    },
    setDefaultHeight() {
      const imgConfigHeight = this.imgConfig.height
      const height = imgConfigHeight + 'px'
      if (this.$refs.ticketImg) {
        this.$refs.ticketImg.style.maxHeight = height
        if (this.$props.config.height) {
          this.$refs.ticketImg.style.height = height
        }
      }
      if (
        (!this.loadImgSrc || this.loadImgStatus === 'Failed') &&
        !this.isFile &&
        typeof imgConfigHeight === 'number'
      ) {
        this.$refs.imgWrap.style.height = height
      }
      if (this.$refs.kyeImgageList) {
        this.$refs.kyeImgageList.style.maxHeight = height
      }
    },
    getFileInfo(url) {
      return this.$props.imglist && this.$props.imglist.length && this.$props.imglist.find(i => i.url === url)
    },
    isSvgImage (url) {
      const info = this.getFileInfo(url)
      return info && info.extendName && info.extendName.toLowerCase() === 'svg'
    },
    getFileTypeIcon(url) {
      const info = this.getFileInfo(url) || {}
      // if (!info) {
      //   return imgSuffixMaps.pdf
      // }
      // return getImgSuffixImg(info.extendName)
      return getImgSuffix(info.extendName)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.ticketImg = this.$refs.ticketImg
      this.initConfig()
    })
    document.addEventListener('keydown', this.handleKeydown)
    this.$bus.$on('on-full-screen-change', this.fullScreenChange)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
    this.$bus.$off('on-full-screen-change', this.fullScreenChange)
  },
  watch: {
    'config.index'(val) {
      this.changeIndex(val)
    },
    'config.imgSrc'(val) {
      this.initConfig()
    },
    loadImgSrc(val) {
      this.$nextTick(() => {
        this.scrollActiveImage()
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/variable.scss';
.ky-erp .el-dialog:has(.waybill-compile_img.kye-image-resize-height) {
  height: inherit !important; // 使用继承的。防止dialog内部计算的
  .el-dialog__body {
    height: calc(70vh - 45px) !important; // 最大高度重置，
    max-height: none !important;
    >div {
      height: 100%;
    }
    .waybill-compile_img {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    .kye-imgage-content-wrap {
      flex: 1;
    }
  }
}
.ky-erp .el-dialog:has(.el-dialog-fullscreen__min).el-dialog:has(.waybill-compile_img.kye-image-resize-height) {
  .el-dialog__body {
    height: calc(100vh - 124px) !important; // 最大高度重置，
    max-height: none !important;
  }
}

.waybill-compile_img {
  position: relative;
  .overHider {
    overflow: hidden;
  }
  .imgbox {
    clear: both;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: 1px solid #eeeeee;
    background-color: #f1f1f5;
  }
  .waybill-compile_img img {
    display: block;
    clear: both;
  }
  .no-img {
    color: #cccccc;
    text-align: center;
    .layout {
      font-size: 36px;
    }
    .no-img-txt {
      display: block;
      padding-top: 20px;
      font-size: 16px;
    }
  }
  .btn-icon {
    display: flex;
    flex-wrap: wrap;
    user-select: none;
    padding: 12px 0 4px;
    width: 100%;
    .pager {
      display: inline-flex;
      align-items: center;
      line-height: 30px;
      cursor: pointer;
      padding: 0 0 0 10px;
    }
    i {
      padding: 0 2px;
      // color: $theme;
    }
    &_left,
    &_left-wrap {
      display: flex;
      align-items: center;
    }
    &_left {
      .el-button.el-button--text:not([style*="display: none"]) {
        margin-left: 0;
      }
    }
    &_right {
      // width: 160px;
    }
  }
  .btn-icon.showGallery {
    justify-content: space-between;
    .pager {
      display: inline-flex;
      align-items: center;
      line-height: 30px;
      cursor: pointer;
      padding: 0;
    }
  }
  .scroll-class {
    /* 滚动条滑块hover */
    &::-webkit-scrollbar-thumb:hover {
      // background-color: rgba(144, 147, 153, 0.3);
      background-color: var(--g-color-scroll-hover-table);
    }
    /* 同时有垂直和水平滚动条时交汇的部分 */
    &::-webkit-scrollbar-corner {
      display: block; /* 修复交汇时出现的白块 */
    }
  }
  .kye-imgage {
    &-container {
      position: relative;
      width: 100%;
      margin: 4px 0;
      background-color: #f7f8fa;
    }
    &-name {
      position: absolute;
      z-index: 99;
      bottom: 0;
      left: 0;
      height: 32px;
      background: linear-gradient(0deg, rgba(13, 32, 57, 0.45) 0%, rgba(13, 32, 57, 0) 100%);
      opacity: 0.8;
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 12px;
      padding-left: 16px;
      width: 100%;
    }
    &-value {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 129px;
    }
  }
  .kye-imgage-content-wrap {
    display: flex;
    height: 100%;
    min-height: 100px;
    overflow: hidden;
    // padding-right: 6px;
    .kye-imgage-current-img {
      flex: 1;
      display: flex;
      align-items: center;
    }
    .kye-imgage-list {
      width: 155px;
      margin-left: 8px;
      overflow-y: auto;
      // padding-right: 6px;
      .kye-imgage-container {
        cursor: pointer;
      }
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
      }
      /* 滚动条有滑块的轨道部分 */
      &::-webkit-scrollbar-track-piece {
        background-color: transparent;
        border-radius: 5px;
      }
      /* 滚动条滑块(竖向:vertical 横向:horizontal) */
      &::-webkit-scrollbar-thumb {
        cursor: pointer;
        background-color:rgba(139, 96, 240, 0.4);
        border-radius: 5px;
      }
      .el-image {
        display: block;
        margin-bottom: 8px;
        overflow: unset;
        border: 2px solid transparent;
      }
      .active {
        border: 2px solid var(--g-color-primary);
        box-sizing: border-box;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-image/index.vue